import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=72484917&scoped=true&"
import script from "./LinkButton.vue?vue&type=script&lang=js&"
export * from "./LinkButton.vue?vue&type=script&lang=js&"
import style0 from "./LinkButton.vue?vue&type=style&index=0&id=72484917&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72484917",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72484917')) {
      api.createRecord('72484917', component.options)
    } else {
      api.reload('72484917', component.options)
    }
    module.hot.accept("./LinkButton.vue?vue&type=template&id=72484917&scoped=true&", function () {
      api.rerender('72484917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/core/LinkButton.vue"
export default component.exports